import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import StockReport from "./StockReport";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { FoodContext } from "../../../../../contexts/Food";
import { UserContext } from "../../../../../contexts/User";

const StockIssuanceDeptAction = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const {id} = useParams();
    const { roundOffStock, qtyAmountPoints } = useCustomHooks();
    //getting context values here

    const { foodDeptForSearch } = useContext(FoodContext)

    let {
      loading,
      setLoading,
      authUserInfo
    } = useContext(UserContext);

    // States hook here
    //new stock issuance
    let [newStockIssuance, setNewStockIssuance] = useState({
      document_no: "",
      ref_identity:"",
      fdept: null,
      tdept: null, 
      remarks: "",
    });
    //new Row
    const [newRow,setNewRow]=useState([]);
    //datepicker
    const [documentDate, setDocumentDate] = useState(new Date());
  
    const [storeReqDoc, setStoreReqDoc] = useState([]);

    const handleSetEditView = (editIssuance) =>{
      let docDate=new Date(editIssuance.document_date);
  
      setNewStockIssuance({
        ...newStockIssuance,
        is_post: editIssuance.is_post,
        document_no:editIssuance.document_identity,
        fdept: editIssuance.from_dept,
        tdept: editIssuance.to_dept,
        ref_identity:{
          id: null,
          document_identity: editIssuance.ref_identity
        },
        remarks: editIssuance.remarks,
      })
      setDocumentDate(docDate);
      
      if(editIssuance.stock_issuance_detail && editIssuance.stock_issuance_detail.length > 0){
        let rowArr=[];
        editIssuance.stock_issuance_detail.map((item)=>{
          rowArr.push({
            item:{
              id: item.item_id,
              name: item.item_name,
            },
            unit:{
              id: item.unit_id,
              name: item.unit_name
            },
            qty: roundOffStock(item.qty),
            max_qty: roundOffStock(item.qty),
            stock_qty: roundOffStock(item.stock_qty)
          })
        })
        setNewRow([...rowArr]);
      }
    };

    //Get Specific item for edit
    const getStockIssuanceItem = async () => {
      setLoading(true);
      const url = BASE_URL + "/settings/stock-issuance-dept/" + parseInt(id);
      try {
        const res = await axios
          .get(url, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          });
          if(res){
            handleSetEditView(res.data)
          }
          setLoading(false);
      } catch {
        setLoading(false);
      }
    };

    useEffect(()=>{
      if (id) {
        getStockIssuanceItem()
      }
    },[id]);

    // store req doc no
    const getStoreReqDoc = async(id)=>{
      const url = BASE_URL + "/settings/requisition-branches-list";
      const formData = {
        from_dept_id: newStockIssuance.fdept.id,
        to_dept_id: id,
      }
    
      await axios
        .post(url,formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          if(res.data){
            setStoreReqDoc(res.data.stock_requisitions);
          }      
        }).catch((error) =>{
          console.log("check error",error);
        })
    }

    // store req items
    const getStoreReqItems = async(ref_doc)=>{
      const url = BASE_URL + "/settings/requisition-details-list";
      const formData = {
        id: ref_doc.id,
        from_branch: newStockIssuance.fdept.id,
      }
      await axios
        .post(url,formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
      .then((res) => {
        if(res.data){
          let rowArr = res.data.map((item)=>{
            return{
              ...item,
              qty: item.qty,
              max_qty: Number(item.qty)
            }
          })
          setNewRow(rowArr);
        }      
      }).catch((error) =>{
        console.log("check error",error);
      })
    }
  
    //set each item qty
    const handleItemQty = (index,e) => {
      if(parseFloat(newRow[index].stock_qty) < parseFloat(e.target.value) || (parseFloat(newRow[index].max_qty) < parseFloat(e.target.value))){
        toast.error("Your qty should not be greater than the stock/req. qty.",{
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }else{
        newRow[index].qty=e.target.value;
        setNewRow([...newRow]);
      }
    };
  
    //handle Set dept hook
    const handleSetDept = (dept) => {
        setNewStockIssuance({ ...newStockIssuance, fdept: dept,});
    };

    const handleSetToDept = (tdept) => {
      setNewStockIssuance({ ...newStockIssuance, tdept, ref_identity: "" });
      getStoreReqDoc(tdept?.id);
      setNewRow([]);
    }; 

    const handleSetDocId = (ref_identity) => {
      // newStockIssuance.tdept = null;
      setNewStockIssuance({ ...newStockIssuance, ref_identity });
      getStoreReqItems(ref_identity);
    };

    const handleRemarks=(e)=>{
      setNewStockIssuance({ ...newStockIssuance, remarks:e.target.value });
    }
  
    //post req of stock item update
    const stockItemAxios = async () => {
      let date =
        new Date(documentDate).getFullYear() +
        "-" +
        (new Date(documentDate).getMonth() + 1) +
        "-" +
        new Date(documentDate).getDate();

      let slugArray=[];
      newRow.map((newIssuance) => {
        slugArray.push({
          qty: parseFloat(newIssuance.qty),
          item_id: newIssuance.item.id,
          item_name: newIssuance.item.name,          
          unit_id: newIssuance.unit.id,
          unit_name: newIssuance.unit.name,
          stock_qty: newIssuance.stock_qty,
        });
      });
        
      if(newRow.length === slugArray.length){
        setLoading(true);
        let formData = {
          ...(id && { id: id,}),
          from_dept_id: newStockIssuance.fdept.id, 
          to_dept_id: newStockIssuance.tdept.id,
          document_date: date,
          ref_identity : newStockIssuance.ref_identity.document_identity,
          remarks: newStockIssuance.remarks,
          issuance_details: slugArray,
        };
        const method = id ? "put" : "post"
        const endpoint = "/settings/stock-issuance-dept";
        const url = BASE_URL + endpoint;
        try {
            const res = await axios[method](url, formData, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            });
          setLoading(false);
          toast.success(`${_t(t("Store Requisition has been updated"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          history.push("/dashboard/manage/stock/stock-issuance-dept")
        } catch (error) {
          console.log("check error==>",error);
          setLoading(false);
          toast.error(`${_t(t("Please try again later"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      }
    };
    
    //send to server
    const handleSubmit = (e) => {
      e.preventDefault();
      if (
        newStockIssuance.fdept !== null &&
        newStockIssuance.tdept !== null &&
        newStockIssuance.document_no !== null &&
        documentDate !== null && newStockIssuance.ref_identity !== null
      ) {
        if(newRow.length > 0){
          stockItemAxios();
        }
        else{
          toast.error(`${_t(t("Please select doc with item"))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
      } else {
        toast.error(`${_t(t("Please fill all the required fields"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    };
    
    return (
      <>
        <Helmet>
          <title>{id ? (newStockIssuance?.is_post ? _t(t("View Stock Issuance Dept")) : _t(t("Edit Stock Dept Issuance Dept"))) : _t(t("Add Stock Issuance Dept"))}</title>
        </Helmet>
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <ManageSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div
                    className="fk-scroll--pos-menu table-bottom-info-hide"
                    data-simplebar
                  >
                    <div className="t-pl-15 t-pr-15">
                      {/* next page data spin loading */}
                      {/* <div className={`${dataPaginating && "loading"}`}></div> */}
                      {/* spin loading ends */}
  
                      {/* Loading effect */}
                      {loading === true ? (
                        tableLoading()
                      ) : (
                        <div key="smtp-form">
                          <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                            <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                              <ul className="t-list fk-breadcrumb">
                                <li className="fk-breadcrumb__list">
                                  <span className="t-link fk-breadcrumb__link text-capitalize">
                                    {id ? (newStockIssuance?.is_post ? _t(t("View Stock Issuance Department")) : _t(t("Edit Stock Issuance Department"))) : _t(t("Add Stock Issuance Department"))}
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6 col-lg-7">
                              <div className="row gx-3 align-items-center"></div>
                            </div>
                          </div>
  
                          {/* Form starts here */}
                          <form
                            className="row card p-2 mx-3 mb-5 table-text"
                            onSubmit={handleSubmit}
                            autoComplete="off"
                          >
                            <div className="col-12">
                              <div className="row">
                                <div className="form-group col-4 mt-3">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="document no"
                                      className="control-label"
                                    >
                                      {_t(t("Document no"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control table-text"
                                      id="document_no"
                                      name="document_no"                                      
                                      value={newStockIssuance.document_no}
                                      placeholder="Auto no"
                                      required
                                    />
                                  </div>
                                </div>
  
                                <div className="form-group col-4 text-right mt-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="transfer_date"
                                      className="control-label"
                                    >
                                      {_t(t("Document Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={documentDate}
                                      onChange={(date) => setDocumentDate(date)}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("Document date"))}
                                      shouldCloseOnSelect={false}
                                    />
                                  </div>
                                </div>
                                  
                                <div className="form-group mt-3 col-4">
                                    <div className="mb-1 text-left">
                                    <label
                                        htmlFor="dept"
                                        className="control-label text-truncate"
                                    >
                                        {_t(t("From Department"))}
                                        <span className="text-danger">*</span>
                                    </label>
                                    </div>
                                    <Select
                                    options={foodDeptForSearch || []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newStockIssuance.fdept || ""}
                                    isDisabled={id}
                                    classNamePrefix="select"
                                    onChange={handleSetDept}
                                    maxMenuHeight="200px"
                                    placeholder={
                                        _t(t("Please select from dept")) + ".."
                                    }
                                    styles={customStyle}
                                    required
                                    />
                                </div>
                              </div>
  
                              <div className="row"> 

                                <div className="form-group mt-2 col-4">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="dept"
                                        className="control-label"
                                      >
                                        {_t(t("To Department"))}
                                        <span className="text-danger">*</span>                                        
                                      </label>
                                    </div>
                                    <Select
                                      options={foodDeptForSearch ? foodDeptForSearch.filter((item)=>item.id!==newStockIssuance?.fdept?.id) : []}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newStockIssuance.tdept || null}
                                      classNamePrefix="select"
                                      onChange={handleSetToDept}
                                      maxMenuHeight="200px"
                                      isDisabled={!newStockIssuance.tdept}
                                      styles={customStyle}
                                      placeholder={
                                        _t(t("Please select to dept")) + ".."
                                      }
                                    />
                                </div> 
                                <div className="form-group mt-2 col-4">
                                    <div className="mb-2">
                                      <label
                                        htmlFor="branch"
                                        className="control-label"
                                      >
                                        {_t(t("Select Document Ref"))}
                                        <span className="text-danger">*</span>                                        
                                      </label>
                                    </div>
                                    <Select
                                      options={storeReqDoc}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.document_identity}
                                      getOptionValue={(option) => option.id}
                                      value={newStockIssuance.ref_identity || null}
                                      classNamePrefix="select"
                                      onChange={handleSetDocId}
                                      isDisabled={!newStockIssuance.fdept || newStockIssuance.is_post}
                                      maxMenuHeight="200px"
                                      styles={customStyle}
                                      placeholder={
                                        _t(t("Please select doc")) + ".."
                                      }
                                    />
                                </div>                                                            
                                <div className="form-group mt-2 col-4">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="remarks"
                                      className="control-label"
                                    >
                                      {_t(t("Remarks"))}
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <textarea
                                      type="text"
                                      className="form-control table-text"
                                      id="remarks"
                                      name="remarks"
                                      onChange={handleRemarks}
                                      value={newStockIssuance.remarks || ""}
                                      placeholder="Remarks"
                                      style={{height:"33px"}}
                                    />
                                  </div>
                                </div>
                              </div>                            
                              
                              <div className={`table-responsive mt-3 pr-1 `}
                                style={{maxHeight:"23rem",overflow: "auto"}}>
                                  <table className="table table-bordered-sm table-hover">
                                    <thead className="align-middle">                                    
                                      <tr>                                      
                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border table_child"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Item Name"))}
                                          </span>
                                        </th>                                     
                                        
                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Stock Qty"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Qty"))}
                                          </span>
                                        </th>

                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{fontWeight:500}}>
                                          {_t(t("Unit"))}
                                          </span>
                                        </th>                                    
                                      </tr>
                                    </thead>
                                    {newRow && newRow.length>0 ?
                                      <tbody className="align-middle">
                                        {newRow.map(
                                          (item, index) => {
                                            return (
                                              <tr
                                                className="align-middle"
                                                key={index}
                                              >                                            
                                                <td className="table-text text-capitalize align-middle text-center">                                                
                                                  {item.item?.name}
                                                </td>   
                                                <td className="table-text text-capitalize align-middle text-center">                                                
                                                  {item.stock_qty}
                                                </td>                                              

                                                <td className="table-text text-capitalize align-middle text-center">
                                                  <input
                                                    disabled={newStockIssuance.is_post}
                                                    type="number"
                                                    step={qtyAmountPoints()}
                                                    min="0"
                                                    onKeyDown={(evt) =>
                                                      ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                      evt.preventDefault()
                                                    }
                                                    onWheel={(e) => e.target.blur()}
                                                    className="form-control text-center table-Input table-text"
                                                    onChange={(e)=>handleItemQty(index,e)}
                                                    value={item?.qty || ""}
                                                    placeholder="Qty"
                                                    required  
                                                  />
                                                </td>

                                                <td className="table-text text-capitalize align-middle text-center">                                                                                               
                                                 {item.unit?.name}
                                                </td>
                                              </tr>
                                              );
                                            }
                                          )}
                                      </tbody>
                                    :null}                                    
                                  </table>
                              </div>
  
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                    <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={()=>(history.push("/dashboard/manage/stock/stock-issuance-dept"))}
                                    >
                                      <i className="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                    </button>
                                    {
                                      !newStockIssuance?.is_post &&(
                                        <button
                                        disabled={loading}
                                        type="submit"
                                        className="btn btn-primary rounded"
                                        >
                                          <i className="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                        </button>                                                
                                      )
                                    }
                                </div>                                                    
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
      </>
    );
}

export default StockIssuanceDeptAction